export const ToPersianNumber = (number) => {
    const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return String(number).replace(/[0-9]/g, (match) => persianDigits[parseInt(match)]);
  };